import RouteMap from "../../../../pages/Transactions/RouteMap";

const routerRouteMap = [
    {
        key: "route-map",
        path: "/transactions/route-map",
        element: <RouteMap />,
    },
]

export default routerRouteMap
